<template>
  <div class="boss-main-content-wrap boss-main-content-wrap-custom">
    <table class="boss-phase-table">
      <tr>
        <td class="boss-phase-table-head is-boss-plain">
          <span class="boss-phase-table-head-arrow" />選考フェーズ
        </td>
        <template v-for="(phase, i) in phases">
          <td
            :key="i"
            :class="selectionStyle(i)"
            class="boss-phase-table-head"
            data-test="phase"
          >
            <span class="boss-phase-table-head-arrow" />{{ phase.name }}
          </td>
        </template>
      </tr>
      <tr>
        <td class="is-boss-phase-table-space is-boss-plain" />
        <template v-for="(_, i) in phases">
          <td
            :key="i"
            :class="selectionStyle(i)"
            class="is-boss-phase-table-space"
          />
        </template>
      </tr>
      <tr class="pega-table-border pega-overflow-wrap-break-word">
        <th>日程</th>
        <template v-for="(schedule, i) in transformSelection.schedules">
          <td
            :key="i"
            :class="selectionStyle(i)"
            data-test="schedule"
          >
            {{ schedule | scheduleFilter | formatNoData }}
          </td>
        </template>
      </tr>
      <tr class="pega-table-border">
        <th>評価</th>
        <template v-for="(name, i) in transformSelection.evaluationNames">
          <td
            :key="i"
            :class="selectionStyle(i)"
            data-test="evaluation"
          >
            {{ name | formatNoData }}
          </td>
        </template>
      </tr>
      <tr class="pega-table-border">
        <th>選考ステータス</th>
        <template v-for="(name, i) in transformSelection.statusNames">
          <td
            :key="i"
            :class="selectionStyle(i)"
            data-test="status"
          >
            {{ name | formatNoData }}
          </td>
        </template>
      </tr>
    </table>
  </div>
</template>

<script>
import _ from 'lodash'
import { createDate } from '@/lib/dateUtils.js'
import { mapGetters } from 'vuex'
import SelectionEventBus from '@/lib/selectionEventBus'

export default {
  filters: {
    scheduleFilter: date => createDate(date)?.format('YYYY/MM/DD') ?? '',
    formatNoData: data => data || 'ー'
  },
  props: {
    entryId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      selections: []
    }
  },
  computed: {
    transformSelection () {
      return _.transform(this.selections, (result, value) => {
        result.schedules.push(_.get(value, 'startDate') || '')
        result.evaluationNames.push(_.get(value, 'evaluation.name') || '')
        result.statusNames.push(_.get(value, 'status.name') || '')
        result.selectionStateTypes.push(_.get(value, 'selectionStateType') || '')
      }, {
        schedules: [],
        evaluationNames: [],
        statusNames: [],
        selectionStateTypes: []
      })
    },
    ...mapGetters('settings', ['phases'])
  },
  watch: {
    entryId: {
      handler () {
        this.fetchSelections()
      }
    }
  },
  created () {
    SelectionEventBus.onSelectionUpdate(this.fetchSelections)
    this.fetchSelections()
  },
  beforeDestroy () {
    SelectionEventBus.$off('selection-update')
  },
  methods: {
    fetchSelections () {
      this.$http.secured.get(`entry/view/entries/${this.entryId}/selection_phases`)
        .then(response => this.setProperty(response))
    },
    setProperty (response) {
      this.$set(this, 'selections', response.data)
    },
    selectionStyle (index) {
      switch (this.transformSelection.selectionStateTypes[index]) {
        case 1 :
          return 'is-boss-old'
        case 2 :
          return 'is-boss-current'
        default:
          return ''
      }
    }
  }
}
</script>
